<template>
  <section class="travel-quote-info">
    <h2>Policy Detail</h2>
    <pet-quote-info :formData="formData"></pet-quote-info>
  </section>
</template>

<script>
import PetQuoteInfo from '@/views/components/modules/pet/pet-quote-info'
export default {
  name: 'quote-refer-info',
  components: {PetQuoteInfo},
  props: {
    formData: {
      type: Object,
      default: () => ({})
    }
  },
}
</script>

<style scoped>

</style>
